import LocalizedStrings from "react-localization";

export const dataAssignmentStrings = new LocalizedStrings({
  en: {
    title: "Data Assignment",
    viewCreativesButton: "View Creatives",
    adName: "Ad Name",
    adPaid: "Ad Paid",
    number: "Number",
    status: "Status",
    date: "Date",
    exportButton: "Export",
    resetFiltersButton: "Reset",
    errors: {
      FieldRequired: "There are no buyers selected for locking.",
      LinesMissingOrLocked: "The buyer you selected is locked or not found.",
      LockingNotAllowed: "There was an error, while locking the lines.",
      UnlockingNotAllowed: "There was an error, while unlocking the lines.",
      TotalResultsExceedsMaxAllowed:
        "There are more than 10 000 results. Please refine your search.",
    },
  },
  fr: {
    title: "Assignement des données",
    viewCreativesButton: "Voir les créations",
    adName: "Ad Name",
    adPaid: "Ad Paid",
    number: "Nombre",
    status: "Statut",
    date: "Date",
    exportButton: "Exporter",
    resetFiltersButton: "Réinitialiser",
    errors: {
      FieldRequired: "Aucun élément n'a été sélectionné pour le verrouillage.",
      LinesMissingOrLocked:
        "Le élément que vous avez sélectionné est verrouillé ou introuvable.",
      LockingNotAllowed:
        "Une erreur s'est produite lors du verrouillage des lignes.",
      UnlockingNotAllowed:
        "Une erreur s'est produite lors du déverrouillage des lignes.",
      TotalResultsExceedsMaxAllowed:
        "Il y a plus de 10 000 résultats. Veuillez affiner votre recherche.",
    },
  },
});
